import React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Box, Drawer, List } from '@mui/material';
import { Image as ImageIcon, Home as HomeIcon } from 'react-feather';
import NavItem from 'src/layouts/DashboardLayout/NavBar/NavItem';
import useHashReference from 'src/hooks/useHashReference';

const drawerWidth = 280;

export default function ClientNavBar({ openMobile, parentClientName }) {
  const hashReference = useHashReference(parentClientName);

  const content = (
    <Box marginTop="40px" height="100%" display="flex" flexDirection="column">
      <PerfectScrollbar options={{ suppressScrollX: true }}>
        <Box p={2}>
          <List key="Client Tools">
            <NavItem
              depth={0}
              href={`/client-review/client/${parentClientName}?hashReference=${hashReference}`}
              icon={HomeIcon}
              key="Content Review"
              title="Content Review"
              expanded={openMobile}
            />
            <NavItem
              depth={0}
              href={`/client-review/client/${parentClientName}/assetManager/a?hashReference=${hashReference}`}
              icon={ImageIcon}
              key="Asset Manager"
              title="Asset Manager"
              expanded={openMobile}
            />
          </List>
        </Box>
      </PerfectScrollbar>
    </Box>
  );

  return (
    <React.Fragment>
      <Box sx={{ display: 'flex' }}>
        <Drawer
          variant="permanent"
          sx={[
            {
              width: drawerWidth,
              flexShrink: 0,
              whiteSpace: 'nowrap',
            },
            openMobile
              ? {
                  width: drawerWidth,
                  transition: (theme) =>
                    theme.transitions.create('width', {
                      easing: theme.transitions.easing.sharp,
                      duration: theme.transitions.duration.enteringScreen,
                    }),
                }
              : {
                  transition: (theme) =>
                    theme.transitions.create('width', {
                      easing: theme.transitions.easing.sharp,
                      duration: theme.transitions.duration.leavingScreen,
                    }),
                  overflowX: 'hidden',
                  width: (theme) => theme.spacing(8),
                },
          ]}
          slotProps={{
            paper: {
              sx: [
                openMobile
                  ? {
                      width: drawerWidth,
                      transition: (theme) =>
                        theme.transitions.create('width', {
                          easing: theme.transitions.easing.sharp,
                          duration: theme.transitions.duration.enteringScreen,
                        }),
                    }
                  : {
                      transition: (theme) =>
                        theme.transitions.create('width', {
                          easing: theme.transitions.easing.sharp,
                          duration: theme.transitions.duration.leavingScreen,
                        }),
                      overflowX: 'hidden',
                      width: (theme) => theme.spacing(8),
                    },
              ],
            },
          }}
        >
          {content}
        </Drawer>
      </Box>
    </React.Fragment>
  );
}
